import StaffScheduleDialog from './StaffScheduleDialog.view';

export default StaffScheduleDialog;
